import React from 'react';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function Positioning() {
  return <section className="py-16 bg-gradient-to-br from-blue-900 to-slate-900 text-white" data-id="element-157">
      <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-158">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/20 mb-6" data-id="element-159">
          <Trophy className="w-8 h-8 text-yellow-400" data-id="element-160" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4" data-id="element-161">
          El Sistema N°1 para Profesores de Gimnasia Artística Argentinos
        </h2>

        <h3 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-162">
          GIMNASIA ARTÍSTICA 360 <br className="hidden md:block" data-id="element-163" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400" data-id="element-164">
            Colección Completa
          </span>
        </h3>

        <p className="text-xl text-slate-300 mb-12 font-medium" data-id="element-165">
          12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todos los niveles.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-166">
          {['+280 páginas', '+150 progresiones técnicas', 'Todos los niveles', 'De Jardín a Competencia'].map((feature, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col items-center justify-center gap-2 backdrop-blur-sm" data-id="element-167">
              <CheckCircle2 className="w-6 h-6 text-emerald-400" data-id="element-168" />
              <span className="font-semibold text-sm md:text-base" data-id="element-169">
                {feature}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}